import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IAccNumberField {
	settingsId: string;
	onChange: (value: string) => void;
}

const AccNumberField: React.FC<IAccNumberField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAccNumber') }], [t]);

	return (
		<FormInput
			testId="AccNumberField"
			name={`accNumber-${settingsId}`}
			label="accNumberLabel"
			onChange={onChange}
			maxLength={50}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(AccNumberField);
